import { render, staticRenderFns } from "./Search-bar.vue?vue&type=template&id=3dfc7bf8&"
import script from "./Search-bar.vue?vue&type=script&lang=js&"
export * from "./Search-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports